import axios from "axios";

const URL_AUTH = import.meta.env.VITE_AUTH_URL;

export function DeletePlanService (token, planId)  {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.delete(
        `${URL_AUTH}/api/admin/v1/plan/${planId}`,
        {
          headers: {
            "X-localization": `${window.localStorage.getItem("i18nextLng")}`,
            Authorization: `Bearer ${token}`,
          },
         
        }
      );
      resolve(response.data);
    } catch (error) {
      reject(error);
    }
  });
};